<template>
  <div class="footer" ref="footer">
    <div class="footer-top" :class="mode === 'pc' ? 'f-c-b' : ''">
      <img src="../assets/images/logo_footer.png">
      <div class="footer-top-nav o-h" :class="mode === 'pc' ? '' : 'm-t-15'">
        <div class="nav-item" :class="mode === 'pc' ? '' : 'mt-menu'" v-for="(item, index) in navList" :key="index" @click="routerPush(item.path)">{{item.title}}</div>
      </div>
    </div>
    <div class="footer-bottom">
      <div>地址：{{info.addr}} 电话：{{info.tel}} 邮箱：{{info.email}}</div>
      <div><a href="https://beian.miit.gov.cn">{{info.companyRecord}}</a></div>
    </div>
  </div>
</template>

<script>
import { getFooter } from '../http/api'

export default {
  name: 'Footer',
  data () {
    return {
      mode: '', // width > 678 pc else mobile
      info: {},
      navList: [
        { title: '首页', path: '/' },
        { title: '招聘求职', path: '/positionlist' },
        { title: '关于我们', path: '/about' },
        { title: '联系我们', path: '/contact' },
        { title: '员工通道', path: '/login' }
      ] // 菜单数组
    }
  },
  created () {
    this.mode = this.$com.jugClientWidth() || 'pc'
    this.getFooter()
  },
  methods: {
    getFooter () {
      getFooter().then(res => {
        const info = res.data[0]
        this.info = info
      })
    },
    routerPush (path) {
      if (path === '/login') {
        window.open(this.$com.login)
      } else {
        const curPath = this.$route.path
        if (path !== curPath) {
          this.$router.push({ path: path })
        }
      }
      // const curPath = this.$route.path
      // if (path !== curPath) {
      //   this.$router.push({ path: path })
      // }
    }
  }
}
</script>

<style scoped lang="scss">
  .footer{
    .m-t-15{
      display: flex;
      justify-content: space-between;
      .nav-item{
        padding-right: 0 ;
      }
    }
  }

  .mt-menu{
    font-size: 13px !important;
    &:hover, &-active{
      font-size: 13px !important;
    }
  }
  .footer{
    background-color: #f2f2f2;
    text-align: left;
    a{
      color: #8c8c8c;
      text-decoration: none;
    }
    &-top{
      padding-bottom: 15px;
      border-bottom: 1px solid #d2d6dc;
      img{
        width: 460px;
        height: 52px;
      }
      .nav-item{
        float: left;
        color: #8c8c8c;
        padding-right: 20px;
        font-size: 16px;
        cursor: pointer;
        &:hover, &-active{
          font-weight: 700;
          font-size: 16px;
          color: var(--theme);
        }
      }
    }
    &-bottom{
      padding-top: 15px;
      font-size: 14px;
      div{
        padding: 5px 0;
        color: #8c8c8c;
      }
      span{
        cursor: pointer;
        font-weight: 700;
        margin-left: 20px;
        &:hover{
          color: var(--theme);
        }
      }
    }
  }
  @media (min-width: 1024px) {
    .footer{
      padding: 20px 64px;
      width: calc(100% - 128px);
    }
  }
  @media (min-width: 768px) and (max-width: 1023px) {
    .footer{
      padding: 20px;
      width: calc(100% - 40px);
      &-top{
        &-nav{
          /*display: none;*/
        }
      }
    }
  }
  @media (max-width: 767px) {
    .footer{
      padding: 10px;
      width: calc(100% - 20px);
      &-top{
        &-nav{
          /*display: none;*/
        }
        img{
          width: 301px;
          height: 34px;
        }
      }
    }
  }
</style>
